import { Location } from 'history';
import { PureComponent } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { setHeatmapTracking } from '../../provider/TrackingProvider';
import {
  withTrackingApi,
  WithTrackingApiProps
} from '../../provider/TrackingProvider/withTrackingApi';
import { selectMeta } from '../../provider/Typo3Provider/selectors';
import { Page } from '../../provider/Typo3Provider/types';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';
import { Maybe } from '../../types';
import { getTrackingUrl } from '../../utils/getTrackingUrl';

interface PageViewTrackerProps {}

interface PageViewTrackerState {
  location: Location;
  prevLocation: Location;
  page: Maybe<Page>;
  referrer: string;
  storyboardId: string|null
}

class PageViewTracker extends PureComponent<
  PageViewTrackerProps &
    RouteComponentProps &
    WithTypo3Props &
    WithTrackingApiProps,
  PageViewTrackerState
> {
  public static getDerivedStateFromProps(
    nextProps: PageViewTrackerProps & RouteComponentProps & WithTypo3Props,
    state: PageViewTrackerState
  ): Partial<PageViewTrackerState> | null {
    const meta = selectMeta(nextProps.typo3);
    const page = meta ? meta.page : null;
    const storyboardId = meta ? meta.storyboardId : null;

    if (state.location !== nextProps.location) {
      return {
        location: nextProps.location,
        prevLocation: state.location,
        page,
        storyboardId
      };
    }
    return {
      page,
      storyboardId
    };
  }

  public state: PageViewTrackerState = {
    location: this.props.location,
    prevLocation: this.props.location,
    page: null,
    storyboardId: null,
    referrer: ''
  };

  public trackPageView() {
    const { location, page, referrer, storyboardId } = this.state;

    if (page) {
      this.props.trackingApi.trackPageView({
        url: getTrackingUrl(location, true),
        title: `${page.title} - Busstore`,
        referrerUrl: referrer,
        storyboardId: storyboardId,
      });

      setTimeout(() => setHeatmapTracking(true), 1000);
    }
  }

  public componentDidMount() {
    this.setState({
      referrer: document.referrer
    });
    this.trackPageView();
  }

  public componentDidUpdate(
    prevProps: PageViewTrackerProps,
    prevState: PageViewTrackerState
  ) {
    if (prevState.page !== null) {
      this.setState({
        referrer: getTrackingUrl(prevState.prevLocation)
      });
    }

    const prevLocationString = getTrackingUrl(prevState.location);
    const curLocationString = getTrackingUrl(this.state.location);

    if (this.state.page && (
      prevState.page !== this.state.page || (
        prevLocationString !== curLocationString && this.state.location.pathname === this.state.page.link
      )
    )) {
      this.trackPageView();
    }
  }

  public render() {
    return null;
  }
}

export default withRouter(withTrackingApi(withTypo3(PageViewTracker)));
